export const adminFormDataFormat = ({
  infosStep,
  firstStep,
  secondStep,
  lastStep,
  supervision,
  userRole
}) => {
  const authorId = infosStep.author?.id?.value;
  const receiverValue = infosStep.receiver?.id;
  const receiverIds = (
    Array.isArray(receiverValue) ? receiverValue : [receiverValue]
  )
    .filter(Boolean)
    .map((option) => option.value);

  return {
    ...infosStep,
    ...firstStep,
    ...secondStep,
    ...lastStep,
    supervision: { _id: supervision?._id },
    author:
      userRole === 'users:OWNER'
        ? {
            id: supervision.main_informations.owner.user,
            role: 'users:OWNER'
          }
        : {
            id: supervision.pensioners.find(
              (pensioner) => pensioner._id === authorId
            )?.user,
            role: 'users:PENSIONER'
          },
    receiver: {
      id: receiverIds,
      role: userRole === 'users:OWNER' ? 'users:PENSIONER' : 'users:OWNER'
    }
  };
};
